// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1pbVRf61W7UxRT5R-uXZK8"};